import './select-hour.css'
import React from 'react'
import { HiChevronLeft } from "react-icons/hi";
import { HiChevronRight } from "react-icons/hi";
import { HiOutlineCalendar } from "react-icons/hi";

const SelectHour = () => {
    return (

        <div className='container-hours'>

            <div className='container-hour'>
                <span className='app-little-title hour'>09:00</span>
            </div>

            <div className='container-hour'>
                <span className='app-little-title hour'>09:30</span>
            </div>

            <div className='container-hour'>
                <span className='app-little-title hour'>10:00</span>
            </div>

            <div className='container-hour'>
                <span className='app-little-title hour'>10:30</span>
            </div>

            <div className='container-hour'>
                <span className='app-little-title hour'>11:00</span>
            </div>

            <div className='container-hour'>
                <span className='app-little-title hour'>11:30</span>
            </div>

            <div className='container-hour'>
                <span className='app-little-title hour'>12:00</span>
            </div>

            <div className='container-hour'>
                <span className='app-little-title hour'>12:30</span>
            </div>

            <div className='container-hour'>
                <span className='app-little-title hour'>13:00</span>
            </div>

            <div className='container-hour selected'>
                <span className='app-little-title hour'>13:30</span>
            </div>

            <div className='container-hour'>
                <span className='app-little-title hour'>14:00</span>
            </div>

            <div className='container-hour'>
                <span className='app-little-title hour'>14:30</span>
            </div>

            <div className='container-hour'>
                <span className='app-little-title hour'>15:00</span>
            </div>

            <div className='container-hour'>
                <span className='app-little-title hour'>15:30</span>
            </div>

            <div className='container-hour'>
                <span className='app-little-title hour'>16:00</span>
            </div>

            <div className='container-hour'>
                <span className='app-little-title hour'>16:30</span>
            </div>


        </div>





    )
}

export default SelectHour